$(document).ready(function () {
    var $headerBtn = $('#header-btn');
    if ($headerBtn.length > 0) {
        $headerBtn.prepend(
            '<a href="/admin/zip-media/" class="icon-arrow-right btn js-header-link">Zip Media + Download</a>'
        );
        $headerBtn.prepend(
            '<a href="/admin/delete-cache/" class="icon-arrow-right btn js-header-link">Delete Cache</a>'
        );
    }
});



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/admin.js